export default __webpack_public_path__ + "static/media/Cobirx_workingpaper.1c39a472.pdf";